import { Injectable } from '@angular/core';
import {
    BehaviorSubject,
    catchError,
    mergeMap,
    Observable,
    of,
    Subject,
    throwError,
} from 'rxjs';
import { environment } from '../../../environments/environment';
import { SERVICE_URL } from '../../_urls/service.urls';
import { HttpService } from '../_http/http.service';

@Injectable({
    providedIn: 'root',
})
export class VoProfileService {
    private _location$ = new BehaviorSubject<{
        location: string;
        roles?: string[];
    } | null>(null);
    location$ = this._location$.asObservable();

    private _export$ = new Subject<void>();
    export$ = this._export$.asObservable();

    profileUrl = `${environment.fdmApiBaseUrl}${SERVICE_URL.PROFILE}`;
    registrationCertificateQureryParam = '';

    constructor(private httpService: HttpService) {}

    setLocation(value: { location: string; roles?: string[] } | null) {
        this._location$.next(value);
    }

    getLocation(): { location: string; roles?: string[] } | null {
        return this._location$.value;
    }

    getVoProfiles<T = any>(params: any): Observable<T> {
        const url = `${this.profileUrl}federation/search`;
        return this.httpService.getRecords<T>(url, params);
    }

    // VO pending count grouped by panchayat_id
    getVoPendingCount(
        stateId: string | number,
        districtId: string | number,
        blockId: string | number
    ): Observable<Record<string, number>> {
        const url = `${this.profileUrl}federation/vo-count`;
        return this.httpService.getRecords<Record<string, number>>(url, {
            stateId,
            districtId,
            blockId,
            panchayatId: '',
            villageId: '',
            federationName: '',
            cboType: 1,
            flag: 'TO_BE_APPROVE_DATA',
            cboId: '',
            page: 0,
            size: '',
            sortColumn: 'federation_id',
            sortDirection: 'ASC',
        });
    }
    getVoProfilesByFedId(feid: any, uuid: any): Observable<any> {
        // uuid: 8585d992-2bb0-5370-a41b-1a47ea1e362d
        const url = `${this.profileUrl}federation/${uuid}`;
        return this.httpService.getRecords(url, { fed_id: feid });
    }

    mapShgLinked<T>(data: any): Observable<T> {
        const url = `${this.profileUrl}shg`;
        return this.httpService.getRecords(url, data);
    }

    getAllMapShgLinked(data: any): Observable<any> {
        return this.mapShgLinked<any>(data).pipe(
            mergeMap((response) => {
                if (response && response.totalRecord > 20) {
                    data['size'] = response.totalRecord;
                    return this.mapShgLinked(data).pipe(
                        catchError((error) => {
                            console.log('Error in inner mapShgLinked:', error);
                            return throwError(error);
                        })
                    );
                } else if (response) {
                    return of(response);
                } else {
                    console.log(
                        'Handle the case when response is empty or has an error:',
                        response
                    );
                    return throwError(
                        'Handle the case when response is empty or has an error'
                    );
                }
            }),
            catchError((error) => {
                console.log('Error in outer mapShgLinked:', error);
                return throwError(error);
            })
        );
    }

    getVoGroupCode(cboUuid: string): Observable<any> {
        const url = `${this.profileUrl}federation/${cboUuid}/cbo`;
        return this.httpService.getRecords(url);
    }
}
